import { createAction, ActionsUnion } from "common/reducers/UtilsTypes";
import { Map } from "immutable";

export const UPDATE_FORM = "@rsfForm/UPDATE_FORM";
export const REMOVE_FORM = "@rsfForm/REMOVE_FORM";
export const UPDATE_FORM_ERROR = "@rsfForm/UPDATE_FORM_ERROR";
export const UPDATE_FORM_ERRORS = "@rsfForm/UPDATE_FORM_ERRORS";
export const REMOVE_FORM_KEY = "@rsfForm/REMOVE_FORM_KEY";
export const PUSH_ID = "@rsfForm/PUSH_ID";
export const REMOVE_ID = "@rsfForm/REMOVE_ID";
export const ON_SORT_END = "@rsfForm/ON_SORT_END";

export interface FormUpdateEvent {
  rootPath: (string | number)[];
  name: string;
  value: any;
  editContext?: any;
}

export const RsfFormActions = {
  update: (event: FormUpdateEvent) => createAction(UPDATE_FORM, { event }),
  removeForm: (formName: string) => createAction(REMOVE_FORM, { formName }),
  /**
   * Use this action to manually set a single error on a form field
   */
  updateError: (event: { rootPath: (string | number)[]; name: string; error: string }) =>
    createAction(UPDATE_FORM_ERROR, { event }),
  /**
   * Should only be used by Form component to set the entire errors map
   */
  updateErrors: (event: { rootPath: (string | number)[]; errors: Map<string, string> }) =>
    createAction(UPDATE_FORM_ERRORS, { event }),

  removeFormKey: (rootPath: (string | number)[], name: string) => createAction(REMOVE_FORM_KEY, { rootPath, name }),

  // Form Edit Actions
  pushId: (event: FormUpdateEvent) => createAction(PUSH_ID, { event }),
  removeId: (event: FormUpdateEvent) => createAction(REMOVE_ID, { event }),
  onSortEnd: (event: { rootPath: (string | number)[]; name: string; oldIndex: number; newIndex: number }) =>
    createAction(ON_SORT_END, { event }),
};

export type RsfFormActions = ActionsUnion<typeof RsfFormActions>;
